module.exports = __webpack_public_path__ + "img/u_upload.05212c2c.svg";